export const truncateLargeStrings = (
  myString: string,
  limit: number
): string => {
  if (!myString || myString.length > limit) {
    if (!myString) return '';
    return myString.slice(0, limit).toString().concat('...');
  }
  return myString;
};

export const calculateCardLength = (
  popupContainer: boolean,
  cardType: string,
  variants: any[],
  sumOfAllBadgeText: number,
  CardTypeVariants: { [key: string]: string }
): number => {
  if (cardType === CardTypeVariants.SNACK_CARD_MAP_POPUP) {
    return 20;
  }
  if (popupContainer) return 12;
  if (
    (cardType === CardTypeVariants.DATA_CARD ||
      cardType === CardTypeVariants.SNACK_CARD_INTERNAL) &&
    variants.length >= 1 &&
    sumOfAllBadgeText > 45.5
  ) {
    return 18.5;
  }
  return 52.5;
};

export const calculateWebCardLength = (
  popupContainer: boolean,
  cardType: string,
  CardTypeVariants: { [key: string]: string }
): number => {
  if (popupContainer) return 15.5;
  if (
    cardType === CardTypeVariants.SNACK_CARD_CONTAINER ||
    cardType === CardTypeVariants.SNACK_CARD_CAROUSEL
  ) {
    return 22.5;
  }
  return 52.5;
};
